import { createFileRoute } from '@tanstack/react-router';
import { OttoPilotLayout } from '@/components/OttoPilot';

export const Route = createFileRoute('/dev/OttoPilot/$chatId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { chatId } = Route.useParams();
  return <OttoPilotLayout basePath="/dev/OttoPilot" selectedChatId={chatId} />;
}
